import { render, staticRenderFns } from "./DialogSendReport.vue?vue&type=template&id=3bfcb686&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./DialogSendReport.vue?vue&type=style&index=0&id=3bfcb686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfcb686",
  null
  
)

export default component.exports